// src/api/bonusApi.js
import apiClient from './apiClient';

const bonusClient = apiClient('bonus');

const bonusApi = {
    // ==================== CRUD для бонусных позиций ====================

    /** Получить все бонусные позиции */
    async getAllConfigs() {
        const res = await bonusClient.get('/config');
        return res.data;
    },

    /** Получить только активные позиции */
    async getActiveConfigs() {
        const res = await bonusClient.get('/config/active');
        return res.data;
    },

    /** Получить позицию по ID */
    async getConfigById(id) {
        const res = await bonusClient.get(`/config/${id}`);
        return res.data;
    },

    /** Создать новую бонусную позицию */
    async createConfig(data) {
        const res = await bonusClient.post('/config', data);
        return res.data;
    },

    /** Обновить бонусную позицию */
    async updateConfig(id, data) {
        const res = await bonusClient.put(`/config/${id}`, data);
        return res.data;
    },

    /** Удалить бонусную позицию */
    async deleteConfig(id) {
        const res = await bonusClient.delete(`/config/${id}`);
        return res.data;
    },

    // ==================== Eligibility ====================

    /** Проверить eligibility пользователя по внутреннему ID */
    async checkEligibility(userId) {
        const res = await bonusClient.get(`/eligibility/${userId}`);
        return res.data;
    },

    /** Проверить eligibility пользователя по Telegram ID */
    async checkEligibilityByTelegram(telegramId) {
        const res = await bonusClient.get(`/eligibility/telegram/${telegramId}`);
        return res.data;
    },

    /** Проверить eligibility текущего пользователя */
    async checkMy() {
        const res = await bonusClient.get('/check');
        return res.data;
    },

    // ==================== Bonus Promos ====================

    /** Получить все бонусные промо (админ) */
    async getAllBonusPromos() {
        const res = await bonusClient.get('/promos?all=1');
        return res.data;
    },

    /** Получить бонусные промо пользователя */
    async getBonusPromosByUser(userId) {
        const res = await bonusClient.get(`/promos?userId=${userId}`);
        return res.data;
    },

    // ==================== Validation & Use ====================

    /** Валидация параметров бонусного промо */
    async validate(data) {
        const res = await bonusClient.post('/validate', data);
        return res.data;
    },

    /** Использовать бонус (зафиксировать) */
    async useBonus(data) {
        const res = await bonusClient.post('/use', data);
        return res.data;
    },

    // ==================== Reset Bonus ====================

    /** Сбросить использование бонуса по userId (админ) */
    async resetBonus(userId) {
        const res = await bonusClient.delete(`/reset/${userId}`);
        return res.data;
    },

    /** Сбросить использование бонуса по Telegram ID (админ)
     * @param categoryId - опционально, сбросить только эту категорию
     */
    async resetBonusByTelegram(telegramId, categoryId = null) {
        const url = categoryId
            ? `/reset/telegram/${telegramId}?categoryId=${categoryId}`
            : `/reset/telegram/${telegramId}`;
        const res = await bonusClient.delete(url);
        return res.data;
    },
};

export default bonusApi;
